<template>
    <div id="cookieConsentWrapper" v-show="visible()">
        <div class="row">
            <div class="column">
                <p>
                    We use cookies to help provide you with the best possible online experience.<br />
                    By using this site, you agree that we may store and access cookies on your device. You can find out more and set your own preferences <a href="/cookies">here</a>.
                </p>
                <p>
                    <span class="small secondary button mrb0" @click="set()">CONTINUE</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
    import Cookie from './Cookie.vue';
    export default {
        extends: Cookie,
        methods: {
            visible() {
                return ! this.isCookie();
            }
        }
    };
</script>


// WEBPACK FOOTER //
// CookieConsent.vue?e1d11b06